import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Box } from '@lifeomic/chroma-react/components/Box';

export const useStyles = makeStyles((theme: Theme) => ({
  illustration: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.text.secondary
        : theme.palette.grey['500'],
    strokeWidth: 1,
    height: theme.pxToRem(100),
    width: theme.pxToRem(100),
  },
  textContainer: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.text.secondary
        : theme.palette.grey['700'],
    lineHeight: 1.35,
    textAlign: 'center',
    width: '30%',
    [theme.breakpoints.down('md')]: {
      width: '50%',
    },
  },
}));

export type EmptyPageStateClasses = GetClasses<typeof useStyles>;

export interface EmptyPageStateOwnProps {
  message: string | React.ReactNode;
  illustration: any;
}

export type EmptyPageStateProps = EmptyPageStateOwnProps;

const EmptyPageState = (props: EmptyPageStateProps) => {
  const classes = useStyles(props);
  const { illustration: Illustration, message } = props;

  return (
    <Box direction="column" align="center" gap={0.5} fullWidth>
      <Illustration className={classes.illustration} />
      <Text className={classes.textContainer} size="subbody">
        {message}
      </Text>
    </Box>
  );
};

export default React.memo(EmptyPageState);
